import {
  CONTENT_SEPARATOR,
  DETAILS_CONTENT_KEYS,
  IPlanContent,
  PLAN_DETAILS_PLAN_PERIOD_BENEFIT,
} from '../typings';
import { createPlanNameMatcher, getKeyDetailsContentIcon } from './utils/PlanMetaHelper';
import { PlanKeyDetailsModal } from './common/PlanKeyDetailsModal';
import {
  defaultEstimatesDialog,
  dualKeyDetailsAddons,
  electricityKeyDetailsAddons,
} from './common/planDefaults';
import { InternetOfferPerk } from './common/internetOfferPerk';

const PLAN_TONE = 'promote';
export const affinityVariableEPlusContentCarbonOffsetFree: IPlanContent = {
  test: createPlanNameMatcher([
    'Origin Affinity Variable ePlus - Carbon Offset – 100% Free', // kept the old values for backward compatability
    'Origin Affinity Variable ePlus - 100% Origin Go Zero Natural Gas at no cost', // kept the old values for backward compatability
    'Origin Affinity Variable ePlus - 100% carbon neutral electricity incl in your Plan',
    'Origin Affinity Variable ePlus - 100% carbon neutral natural gas incl in your plan',
  ]),
  content: {
    rateDiscountText: {
      defaultState: {
        defaultFuel: 'Rates variable on a 24 month energy plan',
      },
    },
    keyDetails: {
      defaultState: {
        defaultFuel: [
          {
            contentKey: DETAILS_CONTENT_KEYS.Rates,
            contentValue: 'Variable',
            modalContent: PlanKeyDetailsModal,
            contentIcon: getKeyDetailsContentIcon(DETAILS_CONTENT_KEYS.Rates),
            contentDescription: 'Variable rates',
          },
          {
            contentKey: DETAILS_CONTENT_KEYS.ExitFees,
            contentValue: 'No',
            contentIcon: getKeyDetailsContentIcon(DETAILS_CONTENT_KEYS.ExitFees),
            contentDescription: 'No exit fees. Leave anytime.',
          },
          {
            contentKey: DETAILS_CONTENT_KEYS.BenefitPeriod,
            contentValue: '24 months' + CONTENT_SEPARATOR + PLAN_DETAILS_PLAN_PERIOD_BENEFIT,
            contentIcon: getKeyDetailsContentIcon(DETAILS_CONTENT_KEYS.BenefitPeriod),
            contentDescription: '24 month benefit period',
          },
          {
            contentKey: DETAILS_CONTENT_KEYS.GreenOptions,
            contentValue:
              'Smarter Communities residents enjoy Origin Go Zero Electricity and Origin Go Zero Natural Gas as an added feature.',
            isText: true,
            contentIcon: getKeyDetailsContentIcon(DETAILS_CONTENT_KEYS.GreenOptions),
            contentDescription:
              'Smarter Communities residents enjoy Origin Go Zero Electricity and Origin Go Zero Natural Gas as an added feature.',
          },
        ],
      },
    },

    keyDetailsAddons: {
      defaultState: {
        defaultFuel: [],
        dual: dualKeyDetailsAddons,
        electricity: electricityKeyDetailsAddons,
      },
    },
    perkAccordion: {
      defaultState: {
        dual: [InternetOfferPerk],
        gas: [InternetOfferPerk],
        electricity: [InternetOfferPerk],
        defaultFuel: [],
      },
    },
    uiOptions: {
      defaultState: {
        defaultFuel: {
          planColor: {
            text: {
              styleGuide: 'green',
              odsCore: PLAN_TONE,
            },
            promobox: {
              styleGuide: 'green',
              odsCore: PLAN_TONE,
            },
            bannerText: {
              styleGuide: 'white',
              odsCore: 'white',
            },
          },
        },
      },
    },
    estimatesDialog: defaultEstimatesDialog(),
    termsAndConditionsUrl: {
      defaultState: {
        defaultFuel: '/terms-and-conditions/origin-affinity-variable-eplus/',
      },
    },
  },
};
